import { combineReducers } from 'redux';
import auth from './auth';
import show from './show';
import chat from './chat';

export default combineReducers({
  auth,
  show,
  chat
});
